<template>
  <v-dialog
    v-model="dialog"
    scrollable
    max-width="600px"
    width="100%"
    persistent
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="light-blue" class="mr-2" dark v-bind="attrs" v-on="on">{{
        $t("AddNewTerms")
      }}</v-btn>
    </template>
    <v-card>
      <v-form
        ref="form"
        v-model="valid"
        @submit.prevent="submit"
        lazy-validation
      >
        <v-card-title class="light-blue darken-4 white--text">{{
          $t("AddNewTerms")
        }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col cols="12" class="pb-0">
              <v-text-field
                type="text"
                outlined
                v-model="data.title"
                :rules="reqRules"
                v-bind:label="$t('Title')"
                dense
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                type="text"
                v-model="data.penalty"
                :rules="numberRule"
                v-bind:label="$t('Estimatedpenalty')"
                v-bind:hint="$t('EP1')"
                :suffix="list.currency_code"
                persistent-hint
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="pb-0">
              <vue-editor
                :editor-toolbar="customToolbar"
                v-model="data.description"
                placeholder="Description"
                rows="3"
                max-rows="6"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-5">
          <v-btn color="red" text @click="dialog = false">
            {{ $t("Close") }}
          </v-btn>
          <v-btn color="light-blue" dark @click="submit">
            {{ $t("Save") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import PartnerService from "@/services/PartnerService";
import { VueEditor } from "vue2-editor";
import swal from "sweetalert";

export default {
  name: "AddNewTermsComponent",
  props: ["list"],
  components: { VueEditor },
  data() {
    return {
      dialog: false,
      valid: null,
      error: null,
      data: {},
      reqRules: [value => !!value || this.$t("string719")],
      numberRule: [
        value => !!value || this.$t("string719"),
        value => {
          const pattern = /^\d+(?:\d+)*$/gm;
          return pattern.test(value) || this.$t("string721");
        }
      ],
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }]
      ]
    };
  },
  methods: {
    async submit() {
      await this.$refs.form.validate();
      if (this.valid) {
        this.dialog = false;
        this.data.property_id = this.$route.params.id;
        if (this.valid) {
          await PartnerService.addContractTerms(this.data)
            .then(() => {
              this.$emit("getContract");
              this.data = {};
            })
            .catch(err => {
              this.waitDialog = false;
              swal({
                icon: "error",
                text: err.response.data.errors[0].msg,
                button: {
                  text: this.$t("Close"),
                  className: "swal-close"
                }
              });
            });
        }
      }
    }
  }
};
</script>

<style scoped></style>
